// ClinicMinds wants a strict YYYY-MM-DD. A two-digit year resolves to the
// century that makes the patient a plausible adult (18 to 100), which is 19YY
// for almost everyone. Months come from a selector, so there is no DD/MM versus
// MM/DD ambiguity - it matters with American prospects.
const MIN_AGE = 18
const MAX_AGE = 105

const ageOn = (birth, now) => {
  let age = now.getFullYear() - birth.getFullYear()
  const beforeBirthday =
    now.getMonth() < birth.getMonth() ||
    (now.getMonth() === birth.getMonth() && now.getDate() < birth.getDate())
  if (beforeBirthday) age -= 1
  return age
}

const resolveYear = (raw, now) => {
  const digits = String(raw).trim()
  if (!/^\d{2}$|^\d{4}$/.test(digits)) return null
  if (digits.length === 4) return Number(digits)
  const yy = Number(digits)
  const nineteen = 1900 + yy
  const age19 = now.getFullYear() - nineteen
  return age19 >= MIN_AGE && age19 <= 100 ? nineteen : 2000 + yy
}

export const normaliseDateOfBirth = (
  { day, month, year },
  now = new Date()
) => {
  const y = resolveYear(year, now)
  const m = Number(month)
  const d = Number(day)
  if (!y || !m || !d) return null
  const birth = new Date(y, m - 1, d)
  const exists =
    birth.getFullYear() === y &&
    birth.getMonth() === m - 1 &&
    birth.getDate() === d
  if (!exists || birth > now) return null
  const age = ageOn(birth, now)
  if (age < MIN_AGE || age > MAX_AGE) return null
  return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`
}
